import React from "react";

import Flickity from 'react-flickity-component'

const flickityOptions = {
    groupCells: true,
    wrapAround: true,
    contain: true
}

const videos = [
    {
        url: 'https://www.youtube.com/embed/FRtz4ppCGEE?autoplay=0&mute=0',
        title: 'Amberane - Still good'
    },
    {
        url: 'https://www.youtube.com/embed/egf8h_mVoJ8?autoplay=0&mute=0',
        title: 'Amberane - Footsteps'
    }
   
];

export const VideoGallery = () => {
    const elements = videos.map( (video, index) => 
            <div className="carousel-cell" key={index} >
                <div className="container">
                    <iframe className="responsive-iframe" allowFullScreen="allowFullScreen" src={video.url} title={video.title}></iframe>
                </div>
                
                
            </div>

    );

    return(

        <Flickity
            className={'carousel'}
            elementType={'div'}
            options={flickityOptions}
            disableImagesLoaded={false}
            reloadOnUpdate
            static={true}
            >
             {elements}
        </Flickity>

    );

};